import React, {useEffect, useMemo, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Redirect, Route, Switch, useHistory} from "react-router-dom";
import "../../components/Dashboard.scss";
import {selectCv, selectFollows, selectUser, storeCv} from "../../slices/profile";
import "./index.scss";
import {StudentCvInterface} from "../../db/models/student/cv";
import {ROUTES} from "../../db/models/const";
import StudentGridLayout from "./StudentGridLayout";
import {completedRmNotificationSent, followingRmArrayToStore, studentFollowingRmIdArray} from "../../helpers/student";
import { getCvListener } from "../../api/student/cv";
import { StudentMe } from "./StudentMe";
import { StudentFeed } from "./StudentFeed";
import StudentFollow from "./StudentFollow";
import { StudentFollowGame } from "./StudentFollowGame";
import StudentSettings from "./Settings/main";
import {StudentProfile} from "./StudentProfile";
import {StudentCompanyExplore} from "./StudentCompanyExplore";
import {StudentRm} from "./StudentRm";
import StudentRmComing from "./RmComing/main";
import {StudentTest} from "./Test/main";
import {StudentSpecial} from "./StudentSpecial";
import StudentOnboarding from "./Onboarding";
import StudentInterest from "./components/Interest/main";
import {Alert, Button} from "react-bootstrap";
import {Logout} from "../../api/auth";

interface Props {
    topRef?: HTMLDivElement;
}

const StudentPrivate: React.FC<Props> = ({topRef}) => {
    const dispatch = useDispatch();
    const user = useSelector(selectUser);
    const follows = useSelector(selectFollows);
    const [followIds, setFollowIds] = useState<string[]>([]);
    const cv = useSelector(selectCv);
    const history = useHistory();
    const toOnboarding = useMemo(() => user?.name === undefined, [user]);

    useEffect(() => {
        const followIds = studentFollowingRmIdArray(user);
        setFollowIds(followIds);
    }, [user]);

    useEffect(() => {
        const unsubscribe = getCvListener({
            next: (doc: any) => {
                let cv: StudentCvInterface = doc.exists ? doc.data() : null;
                dispatch(storeCv(cv));
            },
        });
        return unsubscribe;
    }, []);

    // get followed rm from their ids and save into the store
    useEffect(() => {
        if (!followIds && (followIds as any).length === 0) return;

        followingRmArrayToStore(followIds, dispatch);
    }, [followIds]);

    const onLogout = () => {
        return Logout(dispatch);
    }

    return (
        <Switch>
            {user && !user?.bounded && (
                <Switch>
                    <Route path={ROUTES.ME} exact>
                        {toOnboarding ? (
                            <Redirect to={ROUTES.STUDENT_ONBOARDING}/>
                        ) : (
                            <StudentGridLayout>
                                <StudentMe/>
                            </StudentGridLayout>
                        )}
                    </Route>

                    <Route path={ROUTES.STUDENT_ONBOARDING}>
                        <StudentOnboarding/>
                    </Route>

                    <Route path={ROUTES.FEED} exact>
                        {toOnboarding ? (
                            <Redirect to={ROUTES.STUDENT_ONBOARDING}/>
                        ) : (
                            <StudentGridLayout>
                                <StudentFeed topRef={topRef}/>
                            </StudentGridLayout>
                        )}
                    </Route>
                    <Route path={ROUTES.FOLLOW} exact>
                        {toOnboarding ? (
                            <Redirect to={ROUTES.STUDENT_ONBOARDING}/>
                        ) : (
                            <StudentGridLayout>
                                <StudentFollow/>
                            </StudentGridLayout>
                        )}
                    </Route>
                    <Route path={ROUTES.FOLLOW_GAME} exact>
                        {toOnboarding ? (
                            <Redirect to={ROUTES.STUDENT_ONBOARDING}/>
                        ) : (
                            <StudentGridLayout>
                                <StudentFollowGame/>
                            </StudentGridLayout>
                        )}
                    </Route>
                    <Route path={ROUTES.SETTINGS} exact>
                        {toOnboarding ? (
                            <Redirect to={ROUTES.STUDENT_ONBOARDING}/>
                        ) : (
                            <StudentGridLayout>
                                <StudentSettings/>
                            </StudentGridLayout>
                        )}
                    </Route>
                    <Route path={ROUTES.PROFILE} exact>
                        {toOnboarding ? (
                            <Redirect to={ROUTES.STUDENT_ONBOARDING}/>
                        ) : (
                            <StudentGridLayout>
                                <StudentProfile topRef={topRef}/>
                            </StudentGridLayout>
                        )}
                    </Route>
                    <Route path={ROUTES.COMPANY} exact>
                        {toOnboarding ? (
                            <Redirect to={ROUTES.STUDENT_ONBOARDING}/>
                        ) : (
                            <StudentGridLayout>
                                <StudentCompanyExplore/>
                            </StudentGridLayout>
                        )}
                    </Route>
                    <Route path={ROUTES.STUDENT_RM} exact>
                        {toOnboarding ? (
                            <Redirect to={ROUTES.STUDENT_ONBOARDING}/>
                        ) : (
                            <StudentGridLayout>
                                <StudentRm/>
                            </StudentGridLayout>
                        )}
                    </Route>
                    <Route path={ROUTES.STUDENT_INTEREST} exact>
                        {toOnboarding ? (
                            <Redirect to={ROUTES.STUDENT_ONBOARDING}/>
                        ) : (
                            <StudentGridLayout>
                                <StudentInterest handleGoNext={() => history.push(ROUTES.FEED)}/>
                            </StudentGridLayout>
                        )}
                    </Route>
                    <Route path={ROUTES.STUDENT_RM_COMING} exact>
                        {toOnboarding ? (
                            <Redirect to={ROUTES.STUDENT_ONBOARDING}/>
                        ) : (
                            <StudentGridLayout>
                                <StudentRmComing/>
                            </StudentGridLayout>
                        )}
                    </Route>
                    <Route path={ROUTES.STUDENT_TEST} exact>
                        {toOnboarding ? (
                            <Redirect to={ROUTES.STUDENT_ONBOARDING}/>
                        ) : (
                            <StudentGridLayout>
                                <StudentTest/>
                            </StudentGridLayout>
                        )}
                    </Route>
                    <Route path={ROUTES.SPECIAL}>
                        {toOnboarding ? (
                            <Redirect to={ROUTES.STUDENT_ONBOARDING}/>
                        ) : (
                            <StudentGridLayout>
                                <StudentSpecial/>
                            </StudentGridLayout>
                        )}
                    </Route>

                    <Redirect to={ROUTES.ME}/>
                </Switch>
            )}
            {user && user.bounded && <div className={"container"}>
                <Alert variant="danger">Permission denied</Alert>
                <Button className={""} onClick={() => onLogout()}>Logout</Button>
                </div>}
        </Switch>
    );
};

export default StudentPrivate;
